import {useSelector} from 'react-redux';

import {useIsMinLargeMobile, useIsMinLargeTablet} from '~/shared/hooks/deviceInfo';
import {selectMobileShowRestaurantFilters, selectSearchMode} from '~/shared/store/storeModules/ui/uiSelectors';

const useHideHeader = ({isMenuPage}: {
  isMenuPage: boolean;
}) => {
  const isMinLargeMobile = useIsMinLargeMobile();
  const isMinLargeTablet = useIsMinLargeTablet();
  const isMobileRestaurantsFiltersOpen = useSelector(selectMobileShowRestaurantFilters);
  const searchMode = useSelector(selectSearchMode);

  const hideHeaderBreakpoint = isMenuPage ? isMinLargeTablet : isMinLargeMobile;

  return !hideHeaderBreakpoint && (isMobileRestaurantsFiltersOpen || searchMode);
};

export default useHideHeader;
